// extracted by mini-css-extract-plugin
export default {"select":"TreatmentsComponent_select__mpXdB","row":"TreatmentsComponent_row__sIHD4"};